//import React from "react";
import "./SearchResult.scss";
import Chart from "./Chart";
import TableWrapper from './TableWrapper';
import logo from "../../images/logo.png";
import CleanNav from "../CleanNav/CleanNav";
import FooterSearch from "../FooterSearch/FooterSearch";

const SearchResult = (props) => {
  return (
    <div>
      <CleanNav/>
      <div className="container-result">
        <div className="row">
          <div className="col-lg-4 col-md-12 col-12">
            <div className="search-result-logo text-lg-end">
              <a href="/">
                <img src={logo} height="37" width="100" alt="logo" />
              </a>
            </div>
          </div>

          <div className="col-lg-8 col-md-12 col-12">
            <div className="input-group result-search-bar">
              <input
                className="form-control"
                placeholder="Search"
                value={props.searchQuery}
                onChange={props.handleChange}
                onKeyDown={props.handleEnter}
              />
              <span
                className="input-group-text btn-result-search"
                onClick={props.handleSearch}
              >
                <span className="fa fa-search icon"></span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        {!props.loader ? (
          <div>
              <Chart randomData={props.randomData}/>
            { loadSearchData(props.searchedData, props.chartRef, props.chartWidth)}
          </div>)
        : (
          <div className="loader-center">
            <div className="spinner-border" >
            </div>
              {/*<p className="">Loading...</p>*/}
          </div>
        )}
      </div>
      <FooterSearch/>
    </div>
  );
};

const loadSearchData = (searchedData, chartRef, chartWidth) => {
  if (searchedData) {
    if(searchedData.length) {
      return searchedData?.map((item, index) => (
       <TableWrapper key={item.id} index={index} id={item.id} name={item.name} json={item.json} chartRef={chartRef} chartWidth={chartWidth} />
       //20240316 jag switched item.name to item.id
       //<TableWrapper key={item.name} index={index} name={item.name} json={item.json} chartRef={chartRef} chartWidth={chartWidth} />
      ));
    }
    return <p className="noData">I am sorry, no data found.  Try simplifying your request.</p>
  }
  return null
};



export default SearchResult;
